<mic-spinner-overlay
  id="transfer-casing-spinner-overlay"
  ariaLabel="In Progress"
  color="primary"
  [loading]="isTransferLoading"
  class="no-top-space"
>
  <mic-breadcrumb>
    <mic-breadcrumb-link link="/home/dashboard" icon="home" ariaLabel="Home"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/search-casings"
      label="{{ this.translationService.translate('searchCasingsText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ this.translationService.translate('casingListText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ this.translationService.translate('transferCasingsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="mb-2">{{ this.translationService.translate('transferCasingsHeaderText') }}</h3>

  <mat-card>
    <mat-card-content class="mt-2">
      <form [formGroup]="workOrderFilterForm">
        <div class="filter-container" style="display: flex; align-items: flex-start; gap: 16px">
          <mat-form-field appearance="fill" class="filter-item">
            <mat-label>{{ translationService.translate('searchByWorkOrdersText') }}</mat-label>
            <input
              id="workOrderNumberInput"
              matInput
              formControlName="workOrderNumber"
              placeholder="{{ translationService.translate('enterWorkOrderNumText') }}"
            />
            <button id="search-work-order-num" disabled mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>

          <div class="filter-item">
            <mic-dropdown-search
              micDropdownAccessibility
              id="workOrderPlantInput"
              formControlName="workOrderPlant"
              [data]="plantList"
              [widthConfig]="{ width: '100%' }"
              placeholder="{{ translationService.translate('selectPlantText') }}"
              label="{{ translationService.translate('searchByPlantText') }}"
              searchPlaceholder="Search"
              subscriptSizing="dynamic"
              [multiple]="true"
              [attribute]="'displayName'"
              allLabel="All"
              [compareWith]="compareById"
            >
            </mic-dropdown-search>
          </div>

          <div class="filter-item">
            <mic-dropdown-search
              micDropdownAccessibility
              id="workOrderSiteInput"
              formControlName="workOrderSite"
              [data]="siteList"
              [widthConfig]="{ width: '100%' }"
              placeholder="{{ translationService.translate('selectSiteText') }}"
              label="{{ translationService.translate('searchBySiteText') }}"
              searchPlaceholder="Search"
              subscriptSizing="dynamic"
              [attribute]="'displayName'"
              [multiple]="true"
              allLabel="All"
              [compareWith]="compareById"
            >
            </mic-dropdown-search>
          </div>

          <div class="button-container">
            <button
              id="clear-selection-button"
              type="button"
              mat-flat-button
              color="accent"
              (click)="clearSelections()"
              style="margin-right: 25px"
            >
              <mat-icon>refresh</mat-icon> {{ translationService.translate('clearSelectionText') }}
            </button>

            <button
              id="cancel-transfer-button"
              type="button"
              mat-flat-button
              class="mic-btn-outline"
              style="margin-right: 12px"
              (click)="onCancel()"
            >
              {{ translationService.translate('cancelText') }}
            </button>

            <button id="transfer-button" type="button" mat-flat-button color="primary" (click)="onTransfer()" [disabled]="!canTransfer()">
              <mat-icon>transfer_within_a_station</mat-icon> {{ this.translationService.translate('transferText') }}
            </button>
          </div>
        </div>

        <div class="filter-container" style="display: flex; align-items: flex-start; gap: 16px">
          <button
            id="searchCustomerInput"
            mat-flat-button
            class="mic-btn-icon-left"
            style="height: 56px"
            (click)="openCustomerModal()"
            type="button"
          >
            <mat-icon>search</mat-icon>
            <span>{{ translationService.translate('searchCustomerText') }}</span>
          </button>

          <mat-form-field subscriptSizing="dynamic" class="filter-item">
            <mat-label>{{ translationService.translate('customerCodeText') }}</mat-label>
            <input id="customerCodeInput" matInput type="text" formControlName="customerCode" />
          </mat-form-field>

          <mat-form-field subscriptSizing="dynamic" class="filter-item">
            <mat-label>{{ translationService.translate('customerNameText') }}</mat-label>
            <input id="customerNameInput" matInput type="text" formControlName="customerName" />
          </mat-form-field>
        </div>
      </form>

      <mic-table
        id="transferCasingWorkOrderTable"
        class="table-stripped cam-table"
        [config]="tableConfig"
        [fetcher]="fetcher"
        [uniqueKey]="'id'"
      >
        <ng-container *micTableColumnSelector>
          <div style="display: flex; align-items: center; gap: 16px">
            <button mat-flat-button><mat-icon>view_column</mat-icon>{{ translationService.translate('columnsButtonText') }}</button>
            @if (selectedWorkOrder) {
            <span class="selected-work-order-text">Selected: {{ selectedWorkOrder.workOrderNumber }}</span>
            }
          </div>
        </ng-container>

        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('noDataDisplayText') }}"> </mic-empty-state>
        </ng-container>
      </mic-table>
    </mat-card-content>
  </mat-card>
</mic-spinner-overlay>
<mic-modal #customerModal></mic-modal>
<ng-template #customerModalContent>
  <mic-customer-select-model [dealerId]="dealer?.id" [userLogin]="userLogin" [plantId]="plantId" (result)="onCustomerSelected($event)">
  </mic-customer-select-model>
</ng-template>
